module.exports = function getResource(label, vars = []) {
    let resources = { viewAll: 'Voir tout' };
    return resources[label];
};
